var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAirplay = function SvgAirplay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12 14.294c.178 0 .347.08.46.216l4.707 5.646a.601.601 0 0 1-.46.985H7.293a.6.6 0 0 1-.461-.985l4.706-5.646.095-.092a.6.6 0 0 1 .366-.124M8.575 19.94h6.85L12 15.83zM19.53 3a2.483 2.483 0 0 1 2.482 2.482v9.412a2.48 2.48 0 0 1-2.482 2.482h-.941a.601.601 0 0 1 0-1.2h.941a1.283 1.283 0 0 0 1.282-1.282V5.482A1.285 1.285 0 0 0 19.53 4.2H4.471a1.284 1.284 0 0 0-1.283 1.283v9.412a1.285 1.285 0 0 0 1.283 1.282h.94a.601.601 0 0 1 0 1.2h-.94a2.485 2.485 0 0 1-2.483-2.482V5.482A2.483 2.483 0 0 1 4.471 3z"
  })));
};
export default SvgAirplay;